import { render, staticRenderFns } from "./RA_2DSetup.vue?vue&type=template&id=5aad36ec&scoped=true&"
import script from "./RA_2DSetup.vue?vue&type=script&lang=ts&"
export * from "./RA_2DSetup.vue?vue&type=script&lang=ts&"
import style0 from "./RA_2DSetup.vue?vue&type=style&index=0&id=5aad36ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad36ec",
  null
  
)

export default component.exports